export default "__VITE_ASSET__7N6K_k8S__"